import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Events, scroller } from 'react-scroll';

import { sectionType } from '../utils';
import { product } from '../../../../styles/theme';

const Button = styled.button`
  appearance: none;
  background-color: transparent;
  border: none;
  outline: none;

  padding: 0 2.75vw;

  font-family: ${p => p.theme.font.sourceSans};
  font-size: 18px;
  font-weight: bold;
  line-height: ${p => p.theme.product.tabs.height}px;
  text-decoration: none;
  text-transform: uppercase;

  color: ${p =>
    p.active ? p.theme.product.tabs.activeColor : p.theme.product.tabs.color};
  transition: color ${p => p.theme.product.tabs.transitionSpeed}ms ease-in-out;

  &:hover {
    color: ${p => p.theme.product.tabs.hoverColor};
  }

  @media (max-width: 900px) {
    font-size: 2vw;
  }
`;

const StyledTab = styled.li`
  display: inline-block;
`;

class Tab extends React.PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    onActive: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    section: sectionType,
    transitionListener: PropTypes.func.isRequired
  };

  moveUnderline = ready => {
    const { active, onActive } = this.props;
    if (active) {
      onActive({
        position: this.ref.offsetLeft,
        ready,
        width: this.ref.offsetWidth
      });
    }
  };

  onClick = () => {
    if (this.props.active) return;

    this.props.onClick(this.props.section.id);
    this.props.transitionListener(true);

    Events.scrollEvent.register('end', () => {
      this.props.transitionListener(false);
      Events.scrollEvent.remove('end');
    });

    scroller.scrollTo(this.props.section.id, {
      offset: -product.tabs.height - 141,
      smooth: true
    });
  };

  setRef = ref => (this.ref = ref);

  componentDidMount() {
    this.moveUnderline(false);
  }

  componentDidUpdate() {
    this.moveUnderline(true);
  }

  render() {
    const { active, section } = this.props;

    return (
      <StyledTab ref={this.setRef}>
        <Button active={active} onClick={this.onClick}>
          {section.label}
        </Button>
      </StyledTab>
    );
  }
}

export default Tab;
